import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { roles } = useAuth();

  const hasAccess = allowedRoles.some(role => roles.includes(role));

  return hasAccess ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
